module.exports = __webpack_public_path__ + "static/media/06.cf59804b.png";